// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BX9BT","top":"styles_top__3AG63"};